import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Page, PageHeader } from "../../../components/ui";
import { createAd } from "../../../services/ads";
import AdForm, { adFormValues, adRequestBody } from "./AdForm";

const CreateAds = () => {
  const history = useHistory();
  const { t } = useTranslation();

  // A new ad is inactive: its banner and video are added on the update page.
  const handleSubmit = async (values) => {
    try {
      const data = await createAd(adRequestBody({ ...values, status: false }));
      toast.success(t("Ad created successfully!"));
      history.push(`/dashboard/update-ad/${data?.savedAds?._id}`);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(t("Error creating ad."));
    }
  };

  return (
    <Page>
      <PageHeader
        title={t("Create Ad")}
        subtitle={t("You will add the banner or the video on the next step")}
      />
      <AdForm
        initialValues={adFormValues()}
        onSubmit={handleSubmit}
        submitLabel={t("submit")}
      />
    </Page>
  );
};

export default React.memo(CreateAds);
